import { Component, ViewChild } from '@angular/core';
import { Utilityservice } from '../../utility/utilityservice.service';
import { MenuItem, LazyLoadEvent, SortEvent } from 'primeng/api';
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { ClientgroupmodalComponent } from '../../directives/clientgroupmodal/clientgroupmodal.component';
import { ClientgroupService } from './clientgroup.service';
import { GlobalMessage } from '../../utility/modals';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';
import { BulkexceluploadComponent } from '../../directives/bulkexcelupload/bulkexcelupload.component';
@Component({
  selector: 'app-clientgroup',
  templateUrl: './clientgroup.component.html',
  styleUrls: ['./clientgroup.component.css']
})
export class ClientgroupComponent {
  @ViewChild('dt') dt: any;
  cols: any[];
  downloadformat = false;
  rowsize: number = 10;
  options = [{ label: 10, value: 10 }];
  _selectedColumns: any[];
  customsort: boolean = true;
  showcount: number = 0;
  hidecount: number = 0;
  items: MenuItem[] = [];
  clientgrouplistarray: Array<any> = [];
  paginatorArray = [];
  commonScrollHeight = '';
  clientgrouplist: any;
  excel_paragraph = '';
  bulkModal = false;
  currentCompanyCount = 0;
  numberOfCompany = 0;
  exceldownloadModal = false;
  isOrgAdmin = "";
  message: GlobalMessage = new GlobalMessage();
  userRole:number;
  parentdata: any;
  public totalRecords: number = 0;
  tablecount: number = 0;
  currentPageIndex: number = 0;
  maxMessage = 'Maximum Allowed Client Group/Companies Used';
  tssprtlimitedaccess = "";
  searchTerm: string = ''; 

  ref: DynamicDialogRef | undefined;
  exceluploadenewtext = 'Prerequisites You should have downloaded the Excel format for Client Group creation.You should have updated all the required information for Client Group.The Excel file you choose will be uploaded and verified for accuracy. If there are no errors, the hierarchies will be created. Else, the errors will be displayed on the screen.'
  templatedownloadtext = "";
  constructor(
    private utilityservice: Utilityservice, private ClientgroupService: ClientgroupService, public dialogService: DialogService,
    public PagehelpmodalService: PagehelpmodalService
  ) {
    this.excel_paragraph = this.message.downloadexcel_text;
    this.templatedownloadtext = this.message.excelformate_text;
  }
  handlePageChange(event: any) {
    this.rowsize = event.rows
  }
  dynamiccols() {
    this.cols = [
      { field: 'groupid', header: 'Group ID', type: 'text', sort: false, width: '2px !important', isChecked: true, class: 'headerid' },
      { field: "groupname", header: "Client Group Name", type: 'text', sort: false, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "groupinitial", header: "Client Group Initial", type: 'text', sort: false, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "createdby", header: "Created By", type: 'text', sort: false, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "createdon", header: "Created On", type: 'text', sort: false, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "activeflag", header: "Status", type: 'text', sort: false, width: '20px', isChecked: true, class: 'otherheader' },

    ]
    this._selectedColumns = this.cols;
    this.utilityservice.headerObservable.next(this.cols);
    this.showcount = 4;
    this.hidecount = 2;
  }

  ngOnInit() {
    this.commonScrollHeight = this.utilityservice.scrollHeight
    this.getAllData();
    this.dynamiccols();
    this.getCurrentNumberOfCompany();

  }

  getCurrentNumberOfCompany(): void {
    this.ClientgroupService.getConfiguration().subscribe(
      (response) => {
        if (response && response.length > 0) {
          this.currentCompanyCount = response[0]?.currentCompanyCount;
          this.numberOfCompany = response[0]?.noOfCompany;
          this.isOrgAdmin = response[0]?.isOrgAdmin;
          this.userRole = response[0]?.userRole;
          this.tssprtlimitedaccess = response[0]?.haslimitedaccess;
        }
      },
      (error) => {
        console.error('Error fetching configuration:', error);
      }
    );
  }

  getAllData() {
      const currentPageSize = this.rowsize;
      this.ClientgroupService.getData().subscribe({
        next: (data: any) => {
          this.clientgrouplist = data;
          this.clientgrouplistarray = data.map(item => ({ ...item, isSelect: false }));
  
          this.options = this.utilityservice.getOptionDropdown(data.length);
          this.paginatorArray = this.options.map(e => e.value);
  
          if (!this.paginatorArray.includes(currentPageSize)) {
            this.paginatorArray.push(currentPageSize);
            this.paginatorArray.sort((a, b) => a - b);
          }
  
          this.rowsize = currentPageSize;
          this.totalRecords = this.clientgrouplistarray.length;
          this.tablecount = data.count ?? data.length;
  
          setTimeout(() => {
            if (this.dt) {
              this.dt.first = this.currentPageIndex;
            }
          }, 0);
        },
        error: (error) => {
          const timestamp = new Date().toLocaleString();
          Swal.fire({
            title: error.error?.error || "Error",
            text: `This error occurred at: ${timestamp}`,
            icon: "error",
          });
        }
      });
    }

  customSort(event: SortEvent) {

    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = 0;

      const isDate = (date) => !isNaN(Date.parse(date));

      if (value1 == null && value2 != null) result = -1;
      else if (value1 != null && value2 == null) result = 1;
      else if (value1 == null && value2 == null) result = 0;
      else if (typeof value1 === 'string' && typeof value2 === 'string') {
        if (isDate(value1) && isDate(value2)) {
          const date1 = new Date(value1);
          const date2 = new Date(value2);
          result = date1 < date2 ? -1 : date1 > date2 ? 1 : 0;
        } else {
          result = value1.localeCompare(value2);
        }
      } else {
        result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
      }
      return event.order * result;
    });

  }
  show(title, data) {
    let details = {};
    this.currentPageIndex = this.dt?.first || 0;
    if (title === 'Modify Client Group') {
      this.ClientgroupService.getModify(data.groupid).subscribe((res: any) => {
        if (res.length === 0) {
          Swal.fire({
            icon: 'error',
            title: 'Data Error',
            text: 'Data is null',
          });
        } else {
          details = res;
          this.ref = this.dialogService.open(ClientgroupmodalComponent, {
            header: title,
            width: '55vw',
            height: '28vw',
            data: { title: title, datas: details },
            contentStyle: { overflow: 'auto' },
            baseZIndex: 100
          });
          this.ref.onClose.subscribe(() => {
            this.getAllData();
          });
        }
      })
    } else {
      details = {};
      this.ref = this.dialogService.open(ClientgroupmodalComponent, {
        header: title,
        width: '55vw',
        height: '20vw',
        data: { title: title, datas: details },
        contentStyle: { overflow: 'auto', },
        baseZIndex: 100
      });
      this.ref.onClose.subscribe((res) => {
        this.getAllData();
      });
    }
  } 
  excelUploadFormat() {
    // Call the API to get the Excel template
    this.ClientgroupService.excelUploadFormat().subscribe(
      (response: Blob) => {
        const blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'ClientGroup_ExcelUpload_Format.xlsx';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        Swal.fire('File downloaded successfully!', '', 'success');
      },
      (error) => {
        Swal.fire('Something went wrong while downloading the format.', '', 'error');
      }
    );
  }



  // for downloading data grid
  excelDownload() {
    this.ClientgroupService.getExcelData().subscribe((response: Blob) => {
      const blob = new Blob([response],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Client Group.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.exceldownloadModal = false;
      Swal.fire('File downloaded successfully! ', '', 'success');
    }, error => {
      Swal.fire('Something went wrong', '', 'error');
    });
  }


  openexceluploadmodal() {
      let payload = {}
      this.parentdata = {};
      this.parentdata = {
        title: 'Client Group Data Upload',
        apdownloadapi: 'common/clientgroup/uploadexcel', 
        master: 'Client Group',
        sucessmessage: 'Client Group Data uploaded successfully!', 
        message:`You should have downloaded the Excel format for Client Group creation. You should have updated all the required information. The Excel file you choose will be uploaded and verified for accuracy. If there are no errors, the hierarchies will be created. Else, the errors will be displayed on the screen.`,
      
      }
      this.ref = this.dialogService.open(BulkexceluploadComponent, {
        header: this.parentdata.title,
        width: '70%',
        height: '40',
        data: {
          uploadapi: this.parentdata.apdownloadapi,
          method: 'Post', message: this.parentdata.message, payload: payload,master: this.parentdata.master
        },
        contentStyle: { overflow: 'hidden' },
        position: 'center',
        style: { 'max-width': '100%', 'min-width': '60%' }
      }),
        this.ref.onClose.subscribe(res => {
          if (res == 'uploaded') {
            this.getAllData();
          }
        })
    }


  showBulkUploadDialog() {
    this.bulkModal = true;
  }


    onAddGroupClick() {
      if (
        this.currentCompanyCount < this.numberOfCompany &&
        this.userRole == 1) { 
        this.ClientgroupService.getConfiguration().subscribe(
          (response) => {
            if (response && response.length > 0) {
              this.currentCompanyCount = response[0]?.currentCompanyCount;
              this.numberOfCompany = response[0]?.noOfCompany;
  
              if (this.numberOfCompany <= this.currentCompanyCount) {
                 Swal.fire({
                  icon: 'warning',
                  title: this.maxMessage,
                  text: 'Please Contact Complinity Helpdesk'
                })
              } 
              else {
               this.show('Add Client Group', '');
              }
            }
          },
          (error) => {
            console.error('Error fetching configuration:', error);
          }
        );
      } else {
        Swal.fire({
          icon: 'warning',
          title: this.maxMessage,
          text: 'Please Contact Complinity Helpdesk'
        });
      }
    }
  cleanRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlight(input: string, searchstring: string | number): string {
    if (!searchstring) return input;
    const safeText = String(input ?? '');
    const safeSearch = this.cleanRegExp(String(searchstring));
    const re = new RegExp(safeSearch, 'gi');
    return safeText.replace(re, match => `<span class="highlightsearch">${match}</span>`);
  }
}
